<template>
    <transition name="fade">
        <div class="sign-in">
            <div class="form-container">
                <Icon type="md-close" class="close-icon" size="16" @click="$emit('on-close')"></Icon>
                <div class="title">在线报名</div>
                <div class="sub-title">填写报名信息</div>
                <!-- 姓名,邮箱,手机 -->
                <div class="form-box">
                    <Form ref="signin" :model="form" :rules="rule" :label-width="100">
                        <FormItem label="姓名" prop="name">
                            <Input v-model="form.name" placeholder="请输入参赛者姓名"></Input>
                        </FormItem>
                        <FormItem label="邮箱" prop="email">
                            <Input v-model="form.email" placeholder="请输入邮箱"></Input>
                        </FormItem>
                        <FormItem label="手机" prop="mobile">
                            <Input v-model="form.mobile" placeholder="请输入您的手机号码"></Input>
                        </FormItem>
                        <FormItem  v-for="(item,index) in form.custom_field" :key="index" :label="item.name"  :prop="'custom_field.' + index + '.value'"
                        :rules="{required:item.is_required, message:  item.name+'不能为空', trigger: 'blur'}">
                            <Input v-model="item.value" :placeholder="'请输入'+item.name" v-if="item.type=='text'"></Input>
                            <Date-picker  @on-change="handleChange($event,index)" format="yyyy-MM-dd" type="date" :placeholder="'请选择'+item.name" v-model="item.value" v-if="item.type=='date'"></Date-picker>
                            <Date-picker @on-change="handleChange($event,index)" format="yyyy-MM-dd HH:mm:ss" type="datetime" :placeholder="'请选择'+item.name" v-model="item.value" v-if="item.type=='time'"></Date-picker>

                            <Select v-model="item.value" :placeholder="'请选择'+item.name" v-if="item.type=='select'">
                                <Option :value="i.name" v-for="(i,y) in item.options" :key="y">{{ i.name }}</Option>
                            </Select>
                            <Checkbox-group v-model="item.value" v-if="item.type=='checkbox'">
                                <Checkbox :label="i.name"  v-for="(i,y) in item.options"  :key="y">{{ i.name }}</Checkbox>
                            </Checkbox-group>
                            <Upload
                                action=""
                                :show-upload-list="true"
                                :before-upload="(file) => beforeUpload(file, index)"
                                accept=".jpg,.jpeg,.png,.gif"
                                :format="['jpg', 'jpeg', 'png', 'gif']"
                                v-if="item.type=='img'"
                            >

                                <div class="sign-img-box" style="width: 80px;height:80px;border:1px dashed #ddd;">
                                    <img class="img" v-if="item.value" :src="item.value" style="width: 80px;height:80px;" />
                                    <img v-else src="../../../assets/images/icon-add-match-upload.png" class="icon" />
                                </div>
                            </Upload>
                             <Upload action="" :before-upload="(file) => beforeUpload(file, index)" v-if="item.type=='file'">
                                <Button>上传文件</Button>
                                <a style="margin-left:10px;" v-if="item.value">{{ item.fileName }}</a>
                            </Upload>
                        </FormItem>
                        <FormItem label="获知渠道" prop="source">
                            <Select v-model="form.source" placeholder="请选择获知渠道">
                                <Option v-for="(item,index) in channel" :key="index" :value="item">{{ item }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem v-if="form.source === '其它'" label="其它获知渠道" prop="source_other">
                            <Input v-model="form.source_other" placeholder="请填写获知渠道" />
                        </FormItem>
                        <FormItem>
                            <Checkbox v-model="form.is_agree">
                                <span>我已同意</span>
                                <span style="color:#fa3d5a"  @click.stop="toCommitment(item.id)" v-for="(item,index) in commitments" :key="index">《{{ item.title }}》</span>
                                <span> 等所有条款</span>
                            </Checkbox>
                        </FormItem>
                    </Form>
                    <div class="btn-box">
                        <Button @click="$emit('on-close')">取消</Button>
                        <Button @click="onSubmit">确认报名</Button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { MatchSignIn } from '@/api/social';
import { uploadFileToOSS } from '@/utils/oss';
import { mapState } from 'vuex';
export default{
    name:'SignIn',
    props:{
        uuid:{
            type:String,
            default:""
        },
        commitments:{
            type:Array,
            default: () => {
                return []
            },
        },
        custom_field: {
            type:Array,
            default: () => {
                return []
            },
        }
    },
    data(){
        return{
            channel:[
                '微信公众号/视频号',
                '朋友圈/微信群',
                '抖音','小红书','学校通知','海报/宣传单页','朋友推荐',
                '搜索引擎','其它'
            ],
            form:{
                name:'',
                email:'',
                mobile:'',
                is_agree:false,
                custom_field:[],
                source:'',
                source_other:''
            },
            rule:{
                name:[
                    {required:true,message:'请输入姓名',trigger:'blur'}
                ],
                email:[
                    {required:true,message:'请输入邮箱',trigger:'blur'},
                    {type:'email',message:'请输入正确的邮箱',trigger:'blur'}
                ],
                mobile:[
                    {required:true,message:'请输入手机号',trigger:'blur'},
                ],
                source:[
                    {required:true,message:'请选择来源',trigger:'blur'},
                ],
            }
        }
    },
    watch:{
        'form.source'(news,olds){
            if(olds === '其它' && news !== '其它'){
                this.form.source_other = '';
            }
        }
    },
    computed:{
        ...mapState(['userInfo'])
    },
    mounted(){
        const {uuid} = this;
        if(!uuid){
            this.$layer.msg('非法访问');
            this.$emit('on-close');
            return;
        }
        this.custom_field.forEach((i)=>{
            if(i.type == 'checkbox') {
                i.value = []
            }
            i.is_required = i.is_required == 1 ? true:false
        })
        this.form.custom_field = this.custom_field
    },
    methods:{
        handleChange(e,index) {
            this.form.custom_field[index].value = e
        },
        beforeUpload(file, index) {
            this.uploadSectionFile(file, index)
            return false
        },
        async uploadSectionFile(file, index) {
            const url = await uploadFileToOSS(file, 'template')
            this.form.custom_field[index].value = url
            this.form.custom_field[index].fileName = file.name

        },
        async onSubmit(){
            try{

                console.log('submit-form',this.form);

                const {form,uuid} = this;
                const {is_agree,name,email,mobile,custom_field,source,source_other} = form;
                if(!is_agree){
                    this.$layer.msg('请先同意规则');
                    return;
                }
                if(!name || !email || !mobile){
                    this.$layer.msg('请填写完整信息');
                    return;
                }
                if((source === '其它' && !source_other) || !source){
                    this.$layer.msg('请填写获知渠道');
                    return;
                }
                let msg = ''
                custom_field.forEach((i)=>{
                    if(i.is_required && !i.value) {
                        msg = i.name + '必填'
                    }
                })
                if(msg) {
                    this.$layer.msg(msg);
                    return;
                }
                const param = {};
                param.match_uuid = uuid;
                param.name = name;
                param.email = email;
                param.mobile = mobile;
                param.custom_field = custom_field
                param.source = source;
                param.source_other = source_other;
                console.log('param',param);
                // return
                await MatchSignIn(param);
                this.$layer.msg('报名成功');
                this.$emit('on-close',true);
            }catch(e){
                console.log('e-submit-signin',e);
                this.$layer.msg(e.msg);
            }
        },
        toCommitment(id) {
            const uri = `${window.location.origin}/commitment?id=${id}`;
            window.open(uri, "_blank");
        }
    }
}
</script>
<style lang="scss" scoped>
.sign-img-box{
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon{
        width: 20px;
        height: 20px;
    }
    .img{
        width: 100%;
        height: 100%;
    }
}
@import './singin.scss';
</style>
